import React from 'react';

const Heart = () => (
  <svg
    width={20}
    height={20}
    fill="none"
    aria-hidden="true"
    focusable="false"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
  >
    <path
      d="m10 18-.354.354a.5.5 0 0 0 .708 0L10 18Zm-7.953-7.953-.353.354.353-.354Zm6.667-6.666-.353.353.353-.353ZM10 4.667l-.354.353a.5.5 0 0 0 .708 0L10 4.667Zm1.286-1.286-.354-.354.354.354Zm-.932 14.265L2.4 9.694l-.707.707 7.952 7.953.708-.708Zm7.245-7.952-7.953 7.952.708.708 7.952-7.953-.707-.707Zm-9.238-5.96L9.646 5.02l.708-.707-1.286-1.286-.707.707Zm1.993 1.286 1.286-1.286-.708-.707-1.286 1.286.708.707Zm4.265-3.52c-1.383 0-2.709.55-3.687 1.527l.707.707A4.214 4.214 0 0 1 14.62 2.5v-1Zm4.214 5.214c0 1.118-.444 2.19-1.234 2.98l.707.707a5.214 5.214 0 0 0 1.527-3.687h-1Zm1 0A5.214 5.214 0 0 0 14.62 1.5v1a4.214 4.214 0 0 1 4.214 4.214h1ZM5.381 2.5c1.117 0 2.19.444 2.98 1.234l.707-.707A5.214 5.214 0 0 0 5.38 1.5v1ZM1.167 6.714A4.214 4.214 0 0 1 5.38 2.5v-1A5.214 5.214 0 0 0 .167 6.714h1ZM2.4 9.694a4.214 4.214 0 0 1-1.234-2.98h-1c0 1.383.549 2.71 1.527 3.687l.707-.707Z"
      fill="currentColor"
    />
  </svg>
);

export default Heart;
